import classNames from 'classnames';
import React, { memo } from 'react';

import styles from 'src/widgets/policy/components/links.module.scss';

import { useAnalytics } from '@features/Analytics';

export const TermsLink = memo(
  ({
    place,
    className,
    children,
  }: {
    className?: string;
    place: 'paywall' | 'checkout' | 'burger_menu' | 'email_modal' | 'upsale';
    children?: React.ReactNode;
  }) => {
    const { trackGoogleEvent } = useAnalytics();
    return (
      <a
        className={classNames(styles.link, className)}
        href="https://legal.mentalgrowth.app/eclipse/tos.pdf"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          trackGoogleEvent({
            eventName: 'link_open',
            options: { place: place, link_name: 'terms' },
          })
        }>
        {children || <>Terms of Service</>}
      </a>
    );
  },
);

TermsLink.displayName = 'TermsLink';
